import visaCountriesData from "../../../public/static/data/visa-countries.json"
import countries from "i18n-iso-countries"
import en from "i18n-iso-countries/langs/en.json"
import vi from "i18n-iso-countries/langs/vi.json"

export type VisaCountryEntry = {
  code: string
  name: string
  nameEn: string
}

export type VisaCountryRegion = {
  id: string
  name: string
  nameEn: string
  /** Tên icon FontAwesome (vd "faFire") — xem VISA_REGION_ICON_MAP để map sang IconDefinition thật. */
  icon: string
  countries: VisaCountryEntry[]
}

type VisaCountriesData = {
  popular: VisaCountryEntry[]
  regions: VisaCountryRegion[]
}

const data = visaCountriesData as VisaCountriesData

countries.registerLocale(vi)
countries.registerLocale(en)

let allCountriesCache: VisaCountryEntry[] | null = null
let regionsCache: VisaCountryRegion[] | null = null

const getIsoCountries = (): VisaCountryEntry[] => {
  const namesVi = countries.getNames("vi", { select: "official" })
  const namesEn = countries.getNames("en", { select: "official" })

  return Object.keys(namesVi).flatMap((code) => {
    const name = namesVi[code]
    const nameEn = namesEn[code]
    if (!name || !nameEn) return []
    return [{ code, name, nameEn }]
  })
}

/** Danh sách quốc gia phổ biến — hiện dưới dạng chip nhanh ở box search trang chủ/hub visa. */
export function getVisaPopularCountries(): VisaCountryEntry[] {
  return data.popular
}

/** Các nhóm châu lục + quốc gia trong từng nhóm — dùng cho dropdown chọn điểm đến (2 cột:
 * danh sách châu lục bên trái, danh sách quốc gia bên phải), cấu hình hoàn toàn qua
 * public/static/data/visa-countries.json, không cần sửa code khi cần thêm/bớt quốc gia. */
export function getVisaCountryRegions(): VisaCountryRegion[] {
  if (regionsCache) return regionsCache

  regionsCache = [
    ...data.regions,
    {
      id: "all",
      name: "Tất cả quốc gia",
      nameEn: "All countries",
      icon: "faGlobe",
      countries: getAllVisaCountries(),
    },
  ]

  return regionsCache
}

/** Toàn bộ quốc gia (không trùng theo code) gộp từ mọi region — dùng để lọc theo từ khoá gõ tự do. */
export function getAllVisaCountries(): VisaCountryEntry[] {
  if (allCountriesCache) return allCountriesCache

  const seen = new Set<string>()
  const result: VisaCountryEntry[] = []
  for (const country of [...data.popular, ...getIsoCountries()]) {
    if (seen.has(country.code)) continue
    seen.add(country.code)
    result.push(country)
  }

  allCountriesCache = result
  return allCountriesCache
}

/** Tra cứu 1 quốc gia theo code — dùng khi cần tên hiển thị (vd đổi ngôn ngữ) từ 1 code đã biết. */
export function getVisaCountryByCode(code: string): VisaCountryEntry | undefined {
  return getAllVisaCountries().find((country) => country.code === code)
}
